import axios from 'axios';
import {
  prodApiUrl,
} from '../../config/config';

axios.defaults.baseURL = prodApiUrl;

axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Content-Type'] = 'application/json';

export default axios;



// WEBPACK FOOTER //
// ./src/system/utils/Http.js